import { Helmet } from 'react-helmet';
import {
  Backdrop,
  Box,
  Container,
  Grid,
  Card,
  CardContent,
  Typography,
  CardHeader,
  Button,
  Divider,
  IconButton,
  TextField,
  InputAdornment
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { useCallback, useEffect } from 'react';
import { useBackDrop } from 'src/provider/BackdropProvider';
import { useState } from 'react';
import useApi from 'src/api/api';
import { ArrowBack } from '@material-ui/icons';
import Icons from 'src/icons';
import DataTable from 'src/components/DataTable/DataTable';
import DataTableNoLimit from 'src/components/DataTable/DataTableNoLimit';
import _ from 'lodash';
import { useNavigate } from 'react-router';
import { useLocale } from 'src/provider/LocaleProvider';
import utils from 'src/utils/utils';
import SearchInput from 'src/components/SearchInput';
import LayoutContainer from 'src/layout/LayoutContainer';
import { useAuthData } from 'src/provider/AuthDataProvider';
import RuleSelector from 'src/components/RuleSelector';
const moment = require('moment-timezone');

const useStyles = makeStyles((theme) => ({
  row: {
    // height: '10px',
    // paddingBottom: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(2)
  },
  spacer: {
    flex: 1
  },

  tableCell: {
    '& .MuiTableCell-root': {
      textAlign: 'center',
      borderLeft: 'none !important'
    },
    '& .MuiTableRow-root': {
      height: '60px'
    }
    //
  },
  caption: {
    fontSize: '12px'
  }
}));

const UUnfinishedHomeworkRecord = () => {
  const classes = useStyles();
  const loadingView = useBackDrop();
  const api = useApi();
  const nav = useNavigate();
  const { t, getLanguage } = useLocale();
  const { userInfo, selectedPeriod, currentPeriod } = useAuthData();

  const [filter, setFilter] = useState(null);
  const [record, setRecord] = useState([]);

  const handleExport = () => {
    utils.exportCsv(
      record,
      [
        {
          label: t('date'),
          value: (row) => moment(row['date']).format('YYYY-MM-DD')
        },
        {
          label: t('subject'),
          value: (row) =>
            _.get(row, `homework_type.subject.name.${getLanguage()}`)
        },
        {
          label: t('code'),
          value: (row) => _.get(row, `homework_type.name`)
        },
        {
          label: t('remark'),
          value: (row) => _.get(row, `remarks`)
        },
        {
          label: t('action_created_by'),
          value: (row) => _.get(row, `created_by.name.${getLanguage()}`)
        }
      ],
      'point_record'
    );
  };

  useEffect(() => {
    // loadingView.open()

    api
      .getStudentUnfinishedHomeworkRecord(userInfo._id)
      .then(({ data }) => {
        console.log('data: ', data);
        setRecord(data.records);
      })
      .catch((e) => console.log(e));
    // loadingView.close()
  }, []);

  const filteredList = useCallback(
    utils.searchFilter(record, filter?._id, ['']),
    [record, filter]
  );

  return (
    <LayoutContainer
      title={t('unfinished_homework_record')}
      backSrc="/user/overview"
    >
      <Grid container spacing={1} sx={{ mb: 2 }}>
        {/* <Grid item xs={12} sm={6}>
          <RuleSelector selected={filter} setSelected={setFilter} />
        </Grid> */}
        <Grid item xs={12} sm={12} className="flex ac">
          <div className="spacer"></div>
          <Button onClick={handleExport}>{t('export')}</Button>
        </Grid>
      </Grid>
      <DataTable
        sx={{ mb: 1 }}
        className={classes.tableCell}
        rows={filteredList}
        heads={[
          {
            label: t('date'),
            content: (row) => moment(row.date).format('YYYY-MM-DD'),
            width: '20%',
            sort: true
          },
          {
            label: t('subject'),
            translate: 1,
            content: (row) =>
              _.get(row, `homework_type.subject.name.${getLanguage()}`),
            width: '20%'
          },
          {
            label: t('code'),
            translate: 1,
            content: (row) => _.get(row, `homework_type.name`),
            width: '20%'
          },
          {
            label: t('remark'),
            translate: 1,
            content: (row) => _.get(row, `remarks`),
            width: '20%'
          },
          {
            label: t('action_created_by'),
            content: (row) => _.get(row, `created_by.name.${getLanguage()}`),
            width: '20%'
          }
        ]}
      />
      <div align="right" className={'font12'}>
        Last Updated at {moment().format('YYYY-MM-DD HH:mm:ss')}
      </div>
    </LayoutContainer>
  );
};
export default UUnfinishedHomeworkRecord;
